export enum SyncedSystemType {
  EmailsStorage = 'emailsStorage',
  FilesStorage = 'filesStorage',
  Accounting = 'accounting',
}

export type SyncedSystems = Partial<Record<SyncedSystemType, string>>;
